export const SET_IS_ADMIN = 'SET_IS_ADMIN'
export const SIGN_OUT = 'SIGN_OUT'
export const SIGN_IN = 'SIGN_IN'
export const OPEN_HAMBURGER = 'OPEN_HAMBURGER'
export const CLOSE_HAMBURGER = 'CLOSE_HAMBURGER'
export const SET_DOCID = 'SET_DOCID'
export const SET_PRODUCT = 'SET_PRODUCT'
export const SET_USER = 'SET_USER'
export const RESET = 'RESET'
export const ADD_PENDING_DELETION = 'ADD_PENDING_DELETION'
export const REMOVE_PENDING_DELETION = 'REMOVE_PENDING_DELETION'
export const TOGGLE_LIFE_WEEK = 'TOGGLE_LIFE_WEEK'
